var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticStyle:{"font-weight":"bolder","font-size":"14px"},attrs:{"href":'tel:' + _vm.value.Phone}},[_vm._v(" "+_vm._s(_vm.value.Phone)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }